import {getTrackPreviewUrl} from '@wix/music-shared/dist/src/utils/media/media';

export interface TConverter {
  fromEvent(param): any;
  fromSrc: (src) => any;
  toSrc: (track) => string;
}

export const playersVariants = {
  REMOTE: {
    converter: (tracks) => ({
      toSrc: (track) => track.id,
      fromSrc: (trackId) => tracks.find((track) => track.id === trackId),
      fromEvent({trackId}) {
        return this.fromSrc(trackId);
      },
    }),
  },
  LOCAL: {
    converter: (tracks) => ({
      toSrc: (track) => getTrackPreviewUrl(track.trackURL),
      fromSrc: (src) => {
        const trackURL = src.split('/').pop();
        return tracks.find((track) => track.trackURL === trackURL);
      },
      fromEvent(param) {
        return this.fromSrc(param.src);
      },
    }),
  },
};
